/**
 * @license
 * Copyright (c) 2021 Handsoncode. All rights reserved.
 */
import { AddressDependency, collectDependencies } from '../parser';
import { FormulaCellVertex } from './FormulaCellVertex';
import { MatrixVertex } from './MatrixVertex';
import { RangeVertex } from './RangeVertex';
export const collectAddressesDependentToMatrix = (funcitonRegistry, vertex, matrix, lazilyTransformingAstService, dependencyGraph) => {
    const range = matrix.getRange();
    if (vertex instanceof RangeVertex) {
        const intersection = vertex.range.intersectionWith(range);
        if (intersection !== null) {
            return Array.from(intersection.addresses(dependencyGraph));
        }
        else {
            return [];
        }
    }
    let formula;
    let address;
    if (vertex instanceof FormulaCellVertex) {
        formula = vertex.getFormula(lazilyTransformingAstService);
        address = vertex.getAddress(lazilyTransformingAstService);
    }
    else if (vertex instanceof MatrixVertex && vertex.isFormula()) {
        formula = vertex.getFormula();
        address = vertex.getAddress();
    }
    else {
        return [];
    }
    return collectDependencies(formula, funcitonRegistry)
        .filter((d) => d instanceof AddressDependency)
        .map((d) => d.dependency.toSimpleCellAddress(address))
        .filter((d) => range.addressInRange(d));
};
